<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >

    <template>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :loading="loading"
        :search="search"
        sort-by="calories"
        class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Conceptos de pago: </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" label="Filtrar / Buscar..." class="mx-4" hide-details></v-text-field>
            <v-btn v-if="$store.state.CARGO.id == 1" class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2"> mdi-pencil </v-icon>
              Agregar
            </v-btn>
            <v-btn v-if="$store.state.CARGO.id == 1" class="purple darken-2 white--text ml-2" @click="$router.push('/agrupadores')">
              <v-icon small class="mr-2"> mdi-plus </v-icon>
              Agrupador
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.unidad_medida`]="{ item }">
          <span v-if="item.unidad_medida"> {{ item.unidad_medida.descripcion_SIN }} </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" small color="orange" v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span> Eliminar concepto </span>
          </v-tooltip> -->

          <v-tooltip bottom v-if="$store.state.CARGO.id == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" small color="orange" v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span> Editar concepto </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-0" small color="green" v-bind="attrs" v-on="on" @click="verporunidades(item)">
                mdi-eye
              </v-icon>
            </template>
            <span> Ver Unidades </span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template> -->
      </v-data-table>
    </template>

    <ConceptosAM ref="unidadesam" v-on:onsave="onsave" />
    <ConceptosDEL ref="unidadesdel" />
  </div>
</template>

<script>
  import ConceptosAM from '@/views/conceptos/Conceptosam.vue';
  import ConceptosDEL from '@/views/conceptos/Conceptosdel.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      search: '',
      headers: [
        { text: '#', value: 'nro' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Monto', value: 'monto' },
        //{ text: 'Facturable', value: 'facturable' },
        { text: 'Unidad medida', value: 'unidad_medida' },
        // { text: 'Codigo_sin', value: 'codigo_sin' },
        { text: 'Opciones', value: 'actions' },
      ],
      desserts: [],
      editedIndex: -1,
      id_unidadnegocio: null,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { ConceptosAM, ConceptosDEL },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
      '$store.state.CARGO': function () {
        this.id_unidadnegocio = this.$store.state.CARGO.sede.unidad_negocio;
        this.desserts = [];
        this.getconceptos();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.id_unidadnegocio = this.$store.state.CARGO.sede.unidad_negocio;
        this.desserts = [];
      },

      editItem(item) {
        window.console.log('Editar concepto pago:', item);
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.unidadesam.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },
      verporunidades(item) {
        let url = `/conceptospagobyunidad?idconcepto=${item.id}&name=${item.nombre}`;
        this.$router.push(url);
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      onsave(data) {
        window.console.log('onsave:', data);
        let c = this.desserts.find((c) => c.id == data.id);
        if (c) {
          c.nombre = data.nombre;
          c.descripcion = data.descripcion;
          c.opcional = data.opcional;
          c.facturable = data.facturable;
          c.acepta_descuento = data.acepta_descuento;
          c.monto = data.monto;
          c.order = data.order;
          c.fecha_modificable = data.fecha_modificable;
          c.muestra_asignacion = data.muestra_asignacion;
          c.recaudacion_general = data.recaudacion_general;
          c.asignacion_general = data.asignacion_general;
          c.es_nacional = data.es_nacional;
          c.unidad_id = data.unidad_id;
          c.codigo_sin = data.codigo_sin;
          c.unidad_medida = data.unidad_medida;
        } else {
          this.getconceptos();
        }
      },

      getconceptos() {
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            data.map((c) => {
              c.nro = c.id;
            });
            let filtrados = data.filter((x) => {
              //return x.unidad_id == vue.id_unidadnegocio || !x.unidad_id;
              return x.unidad_id >= 0;
            });
            vue.desserts = filtrados;
            vue.loading = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
    mounted() {
      this.getconceptos();
    },
  };
</script>
